import React from 'react';

import { InstantSearch, Configure, Hits } from 'react-instantsearch-dom';
import { RelatedProducersCarouselHit } from '/components/related-producers-carousel/components';
import algoliasearch from 'algoliasearch/lite';

const RelatedProducersCarousel = ({ producer, comparison }) => {
    const {
        ALGOLIA_APPLICATION_ID,
        ALGOLIA_SEARCH_API_KEY,
        ALGOLIA_INDEX,
    } = window.env;

    const searchClient = algoliasearch(
        ALGOLIA_APPLICATION_ID,
        ALGOLIA_SEARCH_API_KEY,
    );

    let filters = `NOT title:"${producer.title}"`;
    if (comparison === 'products') {
        filters = `${filters} AND (${producer.products.map(product => `facets.products:"${product}"`).join(' OR ')})`;
    }

    return (
        <InstantSearch indexName={ALGOLIA_INDEX} searchClient={searchClient}>
            <Configure
                filters={filters}
                hitsPerPage={4}
                aroundLatLng={`${producer.latitude}, ${producer.longitude}`}
            />
            <Hits
                className="related-producers-carousel"
                hitComponent={RelatedProducersCarouselHit}
            />
        </InstantSearch>
    );
};

export { RelatedProducersCarousel };
